import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    amount: Number,
    commaStyle: {type: String, default: undefined},
    numberScale: {type: String, default: undefined},
    precision: {type: String, default: undefined}
  }

  connect() {
    this.format()
  }

  applyScale(scale) {
    this.numberScaleOverride = scale || ''
    this.format()
  }

  format() {
    if (this.amountValue < 0) {
      this.element.classList.add('text-red-600')
    }
    if(document.querySelector('meta[name="numericFontMonospace"]')?.content === 'true') {
      this.element.classList.add('jetbrains-mono')
    }
    this.element.innerHTML = this.styleAmount(this.amountValue)
  }

  // if any of the below methods are changes pls change in application.js also

  styleAmount(amt) {
    if (parseFloat(amt) === 0) {
      return this.displayZeroAs()
    }
    if (parseFloat(amt) < 0) {
      return `(${new Intl.NumberFormat(this.userCommaStyle(), {minimumFractionDigits: this.precision()}).format(this.roundAmount(amt))})`
    } else {
      return new Intl.NumberFormat(this.userCommaStyle(), {minimumFractionDigits: this.precision()}).format(this.roundAmount(amt))
    }
  }

  precision() {
    if (this.userPrecision() === "") {
      if (this.userRoundPreference() === 'units') {
        return 0
      } else {
        return 2
      }
    } else {
      return parseInt(this.userPrecision())
    }
  }

  userRoundPreference() {
    var scale = this.activeScaleOverride() || this.numberScaleValue
    if (scale === '' || scale === 'null' || scale === 'undefined' || scale === undefined || scale === 'undefined') {
      scale = document.querySelector('meta[name="userRoundPreference"]')?.content || 'units'
    }
    return scale
  }

  activeScaleOverride() {
    return this.numberScaleOverride || this.reportScaleOverride()
  }

  reportScaleOverride() {
    const host = this.element.closest('[data-report-scale]')
    const scale = host && host.getAttribute('data-report-scale')
    return (scale && scale !== '' && scale !== 'default') ? scale : null
  }

  userCommaStyle() {
    var style = this.commaStyleValue
    if (style === '' || style === 'null' || style === 'undefined' || style === undefined || style === 'undefined') {
      style = document.querySelector('meta[name="userCommaStyle"]')?.content || 'indian'
    }
    if (style === 'western') {
      return 'en-US'
    } else {
      return 'en-IN'
    }
  }

  userPrecision() {
    var roundoff = this.activeScaleOverride() ? '' : this.precisionValue
    if (roundoff === '' || roundoff === 'null' || roundoff === undefined || roundoff === 'undefined') {
      roundoff = document.querySelector('meta[name="userPrecision"]')?.content || ""
    }
    return roundoff
  }

  roundAmount(amt) {
    var preference = this.userRoundPreference()
    var rounding = {
      units: 1, thousands: 1000, lakhs: 100000, millions: 1000000, crores: 10000000
    }
    return parseFloat((Math.abs(amt) / rounding[preference]).toFixed(this.precision()))
  }

  displayZeroAs() {
    var meta = document.querySelector('meta[name="displayZeroAs"]')
    if (meta && meta.content === 'zero') {
      return '0'
    } else {
      return '-'
    }
  }

}
